import { ApolloClient } from "apollo-client";
import { ApolloLink } from "apollo-link";
import { onError } from "apollo-link-error";
import { InMemoryCache } from "apollo-cache-inmemory";
import { withClientState } from "apollo-link-state";
import UserQraphQL from "js/graphql/resolvers/programa.resolver";
import AccessQraphQL from "js/components/Access/Access.graphql.js";
import DebounceLink from "apollo-link-debounce";
import { createUploadLink } from "apollo-upload-client";
import AuthService from "js/utils/AuthService";

import { graphqlURL } from "js/constants";

const errorLink = onError(function(error) {
  var graphQLErrors = error.graphQLErrors;
  var operation = error.operation;

  if (!graphQLErrors) return;

  var isAuthError = graphQLErrors.some(function(err) {
    return (
      (err.extensions && err.extensions.code === "UNAUTHENTICATED") ||
      (err.message && err.message.indexOf("Not authenticated") !== -1)
    );
  });

  // No forzar logout si la operación es el propio chequeo de sesión
  if (isAuthError && operation.operationName !== "isLoggedIn") {
    // No redirigir ni limpiar storage si ya estamos en una ruta pública (sin sesión esperada)
    var publicPaths = [
      "/",
      "/landing",
      "/signin",
      "/signup",
      "/restorePassword",
      "/restoreUser",
      "/email-verificado",
      "/catalogo",
      "/catalogo-beneficios"
    ];
    var currentPath = window.location.pathname.replace(/\/$/, "") || "/";
    if (publicPaths.indexOf(currentPath) === -1) {
      AuthService.clearStorage();
      var pathname =
        window.location.pathname.indexOf("/admin") !== -1 ? "/admin" : "/";
      window.location.pathname = pathname;
    }
  }
});

const DEBOUNCE_TIMEOUT = 500;

const cache = new InMemoryCache();

// By settings defaults, we don't need to define explicit Query operations
const defaults = {
  // user: AccessQraphQL.defaults.userDefaults
};

const resolvers = {
  Mutation: {
    writeUser: AccessQraphQL.mutations.writeUser
  },
  Query: { user: UserQraphQL.queries.getUser }
};

const debounceLink = new DebounceLink(DEBOUNCE_TIMEOUT);
const stateLink = withClientState({
  cache,
  defaults,
  resolvers
});
const createApLink = createUploadLink({
  uri: graphqlURL,
  credentials: "include",
  headers: {
    "Apollo-Require-Preflight": true
  }
});

const client = new ApolloClient({
  cache,
  link: ApolloLink.from([debounceLink, stateLink, errorLink, createApLink])
});

export default client;
